import React from 'react'

interface VectrLogoProps {
  className?: string
  alt?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

export const VectrLogo: React.FC<VectrLogoProps> = ({ 
  className = "",
  alt = "Vectr",
  size
}) => {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  }
  
  const finalClassName = size 
    ? `${sizeClasses[size]} ${className}`.trim()
    : className || 'h-8 w-8'

  return (
    <img 
      src="/vectr-logo.svg" 
      alt={alt} 
      className={finalClassName}
      style={{ 
        objectFit: 'contain',
        display: 'block'
      }}
    />
  )
}

